export const UPDATE_PAGINATION_TOTAL_CAMPAIGN: string = "UPDATE_PAGINATION_TOTAL_CAMPAIGN";
export const UPDATE_PAGINATION_POSTS_PER_PAGE_CAMPAIGN: string = "UPDATE_PAGINATION_POSTS_PER_PAGE_CAMPAIGN";
export const UPDATE_PAGINATION_CURRENT_PAGE_CAMPAIGN: string = "UPDATE_PAGINATION_CURRENT_PAGE_CAMPAIGN";
export const UPDATE_LOADING_STATE_CAMPAIGN: string = "UPDATE_LOADING_STATE_CAMPAIGN";
export const UPDATE_NOTFOUND_STATE_CAMPAIGN: string = "UPLOAD_NOTFOUND_STATE_CAMPAIGN";
export const UPDATE_TABLE_STATE_CAMPAIGN: string = "UPDATE_TABLE_STATE_CAMPAIGN";
export const UPDATE_SEARCH_CAMPAIGN: string = "UPDATE_SEARCH_CAMPAIGN";
export const UPDATE_SEARCH_CURRENT_PAGE_CAMPAIGN: string = "UPDATE_SEARCH_CURRENT_PAGE_CAMPAIGN";
export const UPDATE_API_CALL_CAMPAIGN: string = "UPDATE_API_CALL_CAMPAIGN";

export function updateCampaignsPaginationtTotal(totalPostsCampaign: number): IUpdatePaginationTotalActionType {
    return { type: UPDATE_PAGINATION_TOTAL_CAMPAIGN, totalPostsCampaign:totalPostsCampaign };
}
export function updateCampaignsPaginationtPostsPerPage(postsPerPageCampaign: number): IUpdatePaginationPostsPerPageActionType {
    return { type: UPDATE_PAGINATION_POSTS_PER_PAGE_CAMPAIGN, postsPerPageCampaign:postsPerPageCampaign };
}
export function updateCampaignsPaginationcurrentPage(currentPageCampaign: number): IUpdatePaginationCurrentPageActionType {
    return { type: UPDATE_PAGINATION_CURRENT_PAGE_CAMPAIGN, currentPageCampaign:currentPageCampaign };
}
export function updateCampaignsLoadingState(loadingCampaign: string): IUpdateLoadingStateActionType {
    return { type: UPDATE_LOADING_STATE_CAMPAIGN, loadingCampaign:loadingCampaign };
}
export function updateCampaignsNFState(notFoundCampaign: string): IUpdateNFStateActionType {
    return { type: UPDATE_NOTFOUND_STATE_CAMPAIGN, notFoundCampaign:notFoundCampaign };
}
export function updateCampaignsTableState(tableCampaign: string): IUpdateTableStateActionType {
    return { type: UPDATE_TABLE_STATE_CAMPAIGN, tableCampaign:tableCampaign };
}
export function updateCampaignsSearchState(searchCampaign: string): IUpdateSearchStateActionType {
    return { type: UPDATE_SEARCH_CAMPAIGN, searchCampaign:searchCampaign };
}
export function updateCampaignsSearchCurrentPageState(currentPageSearchCampaign: number): IUpdateCurrentPageSearchStateActionType {
    return { type: UPDATE_SEARCH_CURRENT_PAGE_CAMPAIGN, currentPageSearchCampaign:currentPageSearchCampaign };
}
export function updateCampaignsAPICallState(apiCallCampaign: boolean): IUpdateAPICallStateActionType {
    return { type: UPDATE_API_CALL_CAMPAIGN, apiCallCampaign:apiCallCampaign };
}
interface IUpdatePaginationTotalActionType { 
    type: string, 
    totalPostsCampaign: number
}

interface IUpdatePaginationPostsPerPageActionType { 
    type: string, 
    postsPerPageCampaign: number
}

interface IUpdatePaginationCurrentPageActionType { 
    type: string, 
    currentPageCampaign: number
}

interface IUpdateLoadingStateActionType { 
    type: string, 
    loadingCampaign: string
}

interface IUpdateNFStateActionType { 
    type: string, 
    notFoundCampaign: string
}

interface IUpdateTableStateActionType { 
    type: string, 
    tableCampaign: string
}

interface IUpdateSearchStateActionType { 
    type: string, 
    searchCampaign: string
}

interface IUpdateCurrentPageSearchStateActionType { 
    type: string, 
    currentPageSearchCampaign: number
}

interface IUpdateAPICallStateActionType { 
    type: string, 
    apiCallCampaign: boolean
}